import { useQuery } from '@tanstack/react-query';

import getAccountPromo from 'Api/stock-promo/getAccountPromo';
import getAccountPromoResponse from './model/response/getAccountResponse';

const useGetAccountPromo = () => {
  return useQuery({
    queryKey: ['all-account-promo'],
    queryFn: async () => {
      const response = await getAccountPromo();

      const result = getAccountPromoResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetAccountPromo;
